export const ProductType: readonly ["Product", "Service"] = Object.freeze([
    "Product",
    "Service",
] as const);

export const Condition: readonly ["New", "Refurbished", "Used"] = Object.freeze(
    ["New", "Refurbished", "Used"] as const,
);

export const DiscountType: readonly ["None", "Discount", "Loyalty", "Coupon"] =
    Object.freeze(["None", "Discount", "Loyalty", "Coupon"] as const);

export const OrderDirection: readonly ["Sale", "Purchase"] = Object.freeze([
    "Sale",
    "Purchase",
] as const);

export const OrderStatus: readonly [
    "Temporary",
    "Pending",
    "Prepared",
    "Shipped",
    "Canceled",
    "Complete",
] = Object.freeze([
    "Temporary",
    "Pending",
    "Prepared",
    "Shipped",
    "Canceled",
    // "Scheduled",
    "Complete",
] as const);

export const OrderType: readonly ["InStore", "Shipping", "Refund", "External"] =
    Object.freeze(["InStore", "Shipping", "Refund", "External"] as const);

export const SalesChannel: readonly ["Website", "POS", "Partner", "Instagram", "Facebook", "TikTok", "Pinterest", "Amazon", "eBay", "Google"] =
    Object.freeze(["Website", "POS", "Partner", "Instagram", "Facebook", "TikTok", "Pinterest", "Amazon", "eBay", "Google"] as const);

export const PaymentType: readonly ["Cash", "Card"] = Object.freeze([
    "Cash",
    "Card",
] as const);

export const Gender: readonly ["Male", "Female"] = Object.freeze([
    "Male",
    "Female",
] as const);

export const AccountStatus: readonly ["Active", "Suspended"] = Object.freeze([
    "Active",
    "Suspended",
] as const);

export const Role: readonly [
    "None",
    "Employee",
    "Owner",
    "Admin",
] = Object.freeze([
    "None",
    "Employee",
    "Owner",
    "Admin",
] as const);

export const TaxType: readonly ["VAT", "Excise"] = Object.freeze([
    "VAT",
    "Excise",
] as const);

export const PackageStatus: readonly ["Temporary", "NotForSale", "ForSale"] =
    Object.freeze(["Temporary", "NotForSale", "ForSale"] as const);

export const AdjustmentReason: readonly [
    "Display Sample",
    "Incorrect Quantity",
    "Theft",
    "Waste",
    "Move",
    "Destroy",
    "Refund",
    "Sale",
] = Object.freeze([
    "Display Sample",
    "Incorrect Quantity",
    "Theft",
    "Waste",
    "Move",
    "Destroy",
    "Refund",
    "Sale",
] as const);

export const LocationType: readonly ["Address", "Vehicle"] = Object.freeze([
    "Address",
    "Vehicle",
] as const);

export const Day: readonly [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
] = Object.freeze([
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
] as const);

export const WebsiteMode: readonly ["light", "dark"] = Object.freeze([
    "light",
    "dark",
] as const);

export const CardBrand: readonly [
    "American Express",
    "Diners Club",
    "Discover",
    "Eftpos Australia",
    "JCB",
    "MasterCard",
    "UnionPay",
    "Visa",
    "Unknown",
] = Object.freeze([
    "American Express",
    "Diners Club",
    "Discover",
    "Eftpos Australia",
    "JCB",
    "MasterCard",
    "UnionPay",
    "Visa",
    "Unknown",
] as const);

export const Operator: readonly [
    "eq",
    "gt",
    "gte",
    "lt",
    "lte",
    "neq",
    "like",
    "ilike",
    "match",
    "imatch",
    "in",
    "is",
    "isdistinct",
    "fts",
    "plfts",
    "phfts",
    "wfts",
    "cs",
    "cd",
    "ov",
    "sl",
    "sr",
    "nxr",
    "nxl",
    "adj",
    "not",
    "or",
    "and",
    "all",
    "any",
] = Object.freeze([
    "eq",
    "gt",
    "gte",
    "lt",
    "lte",
    "neq",
    "like",
    "ilike",
    "match",
    "imatch",
    "in",
    "is",
    "isdistinct",
    "fts",
    "plfts",
    "phfts",
    "wfts",
    "cs",
    "cd",
    "ov",
    "sl",
    "sr",
    "nxr",
    "nxl",
    "adj",
    "not",
    "or",
    "and",
    "all",
    "any",
] as const);

export type ValuesOf<T extends readonly any[]> = T[number];
